import angular from "angular";
import storageModule from "../storage";

const moduleName = "oidc-auth";
export default moduleName;

angular.module(moduleName, [storageModule])
